<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div
            slot="header"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <HeaderTitle title="Choose Model"></HeaderTitle>
            <b-form-input
              style="display: inline-block; width: 250px;"
              v-model="searchQuery"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
          </div>
          <b-row class="message_container">
            <p v-if="message !== ''">{{ message }}</p>
          </b-row>
          <b-row>
            <LoadingCard v-if="loadingData"></LoadingCard>
            <template v-else>
              <b-col
                v-for="model in filterItems(models)"
                lg="3"
                sm="6"
                :key="model.fns_part"
                style="padding: 5px"
              >
                <a
                  class="locationLabels"
                  :href="'#/model/?part=' + model.fns_part"
                  >{{ model.model }}
                  <span v-if="model.backlog != 0" style="color: yellow">{{
                    model.backlog
                  }}</span></a
                >
              </b-col>
            </template>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";

export default {
  name: "AnalyticsByModel",
  data() {
    return {
      title: "",
      models: [],
      searchQuery: "",
      loadingData: false,
      message: "",
    };
  },
  methods: {
    changeView(value) {
      this.loadingData = true;
      this.message = "";
      this.title = value;
      let params = {};
      params = {
        type: value,
      };
      this.$http
        .get("api/comcast_portal/products/modelsByGroup.php", { params })
        .then(
          (res) => {
            if (res && res.data && res.data.length > 0) {
              this.models = res.data;
              this.message = "";
            } else {
              this.message = "No products found.";
              this.models = [];
            }
            this.loadingData = false;
          },
          (err) => {
            this.loadingData = false;
            console.log(err);
          }
        );
    },
    filterItems: function (models) {
      var app = this;
      return models.filter(function (models) {
        let regex = new RegExp("(" + app.searchQuery + ")", "i");
        return models.model.match(regex);
      });
    },
  },
  mounted() {
    this.changeView("Power Supply");
  },
  components: { LoadingCard, HeaderTitle },
};
</script>

<style>
.message_container {
  display: flex;
  justify-content: center;
}
.mybtns {
  display: block !important;
  margin: auto;
}
.locationLabels {
  padding: 9px;
}
.loading {
  display: block !important;
  margin: auto !important;
}
</style>
